import styled from 'styled-components';

import { colors } from '../../styles/colors';

// 44x44px é a área mínima de toque recomendada para alvos em telas touch;
// o ícone continua pequeno, quem garante a área é o próprio botão.
export const CloseButtonWrapper = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 44px;
  min-height: 44px;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${colors.BlueSecondary};
    outline-offset: -2px;
  }

  svg {
    pointer-events: none;
  }
`;
